export default __webpack_public_path__ + "static/media/pen.2afafc71.svg";